module.exports = __webpack_public_path__ + "media/images/arrow-right-white-837aeb83223a14096da33623f98e60f9.svg";